@import "../../../globalStyles/commons";


.tabs-list {
  display: flex;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
  }

  .tabs-container {
    display: flex;
    align-items: flex-end;
    z-index: 1;
  }
}

.tabs-list.type-default {
  &:before {
    border-bottom: 2px solid v(--border-subtle);
  }
}
